import { render, staticRenderFns } from "./DefaultProductsTable.vue?vue&type=template&id=22b2bbc6&"
import script from "./DefaultProductsTable.vue?vue&type=script&lang=js&"
export * from "./DefaultProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports